import { useNavigate } from "react-router-dom";

import { basePath } from "../containers/ApplicationPage/constants";

import useToken from "./useToken";

export const useAssessmentNavigation = () => {
    const { token, decoded } = useToken();
    const navigate = useNavigate();

    const assessmentCount = decoded.assessmentIds?.length ?? 0;
    const isFeedbackFlow = !!decoded.receiverEmail;
    const hasMultipleAssessments = assessmentCount > 1;
    const hasSingleAssessment = assessmentCount === 1;

    const getBackUrl = () => {
        if (isFeedbackFlow) {
            return `${basePath}/feedback?token=${token}`;
        }
        if (hasMultipleAssessments) {
            return `${basePath}/assessments/overview?token=${token}`;
        }
        if (hasSingleAssessment) {
            return `${basePath}/assessments?token=${token}`;
        }
        return `${basePath}/?token=${token}`;
    };

    const navigateBack = () => {
        navigate(getBackUrl());
    };

    const navigateToAssessments = () => {
        navigate(`${basePath}/assessments?token=${token}`);
    };

    return {
        hasMultipleAssessments,
        backUrl: getBackUrl(),
        navigateBack,
        navigateToAssessments,
    };
};
